
























































































import { Component, Vue } from 'vue-property-decorator'
import UploadButton from 'vuetify-upload-button'
import TOML from '@iarna/toml'
import { mapGetters } from 'vuex'
import { Item } from '@/types/domain'

@Component({
  computed: {
    ...mapGetters('items', [
      'team',
      'devs',
      'hasItems'
    ])
  },
  components: {
    'v-upload-btn': UploadButton
  }
})
export default class ImportItems extends Vue {
  team: Item
  devs: Item[]
  hasItems: boolean

  public uploadToml (file, target = 'devs', index) {
    const reader = new FileReader()
    if (file) {
      reader.addEventListener('load', () => {
        let object
        try {
          object = TOML.parse(reader.result.toString()) as unknown
          this.$store.dispatch('comm/showSnackbar', 'file upload successful')
        } catch (e) {
          console.error('Could not read uploaded file as TOML', e)
          return 1
        }
        const item: Item = {
          filename: file.name,
          title: object.meta.title,
          payload: object
        }
        
        if (target === 'team') {
          this.$store.dispatch('items/uploadTeam', item)
        } else if (target === 'devs') {
          const existingIx = this.devs
            .findIndex(b => b.title === item.title)
          if (existingIx >= 0 && existingIx != index) {
            this.$store.dispatch('comm/showSnackbar', `entry with that title already exists: ${item.title}`)
          } else {
            this.$store.dispatch('items/uploadDev', { item, index })
          }
        }
        this.checkComplete()
      }, false)
      reader.readAsText(file)
    }
  }

  public removeDev (index) {
    this.$store.dispatch('items/deleteDev', index)
    this.checkComplete()
  }

  private checkComplete () {
    if (this.hasItems) {
      this.$emit('isComplete', true)
    } else {
      this.$emit('isComplete', false)
    }
  }

  public loadDummyData () {
    this.$store.dispatch('items/loadDummyData')
    this.checkComplete()
  }
  mounted (): void {
    this.checkComplete()
  }

}
